Vue.component('ppcarto-bar-section-item', {
  props: ['section'],
  template: `<li class="topbar__btngrp__item" v-bind:class="[{'topbar__btngrp__item--selected': isSelected},section.key]">
              <a href="#" class="topbar__btngrp__link" @click="toggleSelected">
                <ppcarto-icon :name="section.key"></ppcarto-icon>
              </a>
              <div class="tooltip">
                <svg class="tooltip__arrow" viewBox="0 0 16 8">
                  <!--<path d="M 0 0 L 16 0 L 8 8 z"></path>-->
                  <path d="M 8 0 L 16 8 L 0 8 z"></path>
                </svg>
                <div class="tooltip__container">
                  <p>{{section.name}}</p>
                </div>
              </div>
              <div class="filter">
                <h2>{{section.name}}</h2>
                <ul class="filter__categories">
                  <li class="filter__categories__item--all" v-bind:class="{active: selectAll}"><a href="#" v-on:click.prevent.stop="doSelectAll">Alle Kategorien</a></li>
                  <li class="filter__categories__item" v-bind:class="{ active: isActive(category) }" v-for="category in section.categories"><a href="#" v-on:click.prevent="toggleSelectedCategory(category)">{{category.name}}</a></li>
                </ul>
              </div>
            </li>`,
    computed: {
      classObject () {
        return 'topbar__btngrp__link--' + this.section.key
      },
      isSelected () {
        return this.$store.state.sections.filter(s => s.key == this.section.key)[0].selected
      },
      activeCategories () {
         return this.$store.state.sections.filter(s => s.key == this.section.key)[0].categories.filter(c => c.active)
      },
      inactiveCategories () {
         return this.$store.state.sections.filter(s => s.key == this.section.key)[0].categories.filter(c => !c.active)
      },
      selectAll () {
        return this.$store.state.sections.filter(s => s.key == this.section.key)[0].categories.filter(c => !c.active) == 0
      },

    },

    methods: {
      toggleSelected () {
        this.$store.commit('toggleSection', this.section)
      },
      toggleSelectedCategory (category) {
        this.$store.commit('toggleSectionCategory', { section: this.section, category: category } )
      },
      doSelectAll () {
        this.inactiveCategories.forEach(category => {
          this.$store.commit('toggleSectionCategory', { section: this.section, category: category } )
        })
      },
      isActive(category){
          return category.active
      },
      layerStatus(){
        return this.$store.getters.getLayerStatus[this.section.key];
      },
    },

    mounted (){

    }

});
